<template>
  <div class="h-100">
    <m-content-wrapper :content-type="contentType" :content-category="contentCategory">
      <template v-slot="{ contents,pagination,changePageFunction }">
        <swiper id="slider302" v-bind="swiperOptions" :navigation="true" :modules="modules"
                class="mySwiper h-100 w-100">

          <swiper-slide v-for="content in contents" :key="content.id" class=" w-100">
            <div class="content-of-main-section">
              <m-a :href="findLinkOnContent(content.abstraction)" class="text-center">
                <img :src="content.thumbnail" class="img-slider " :alt="content.title">
              </m-a>
            </div>
            <div class="position-absolute box-on-image">
              <m-a :href="findLinkOnContent(content.abstraction)" class="text-center">
                <p class="text-right text-white slider-p">
                  {{ content.title }}
                </p>
              </m-a>
              <div class="col-lg-12 text-right p-0 slider-ab">
                <m-a :href="findLinkOnContent(content.abstraction)" class="text-center">
                  <button class="button-slider btn rounded-0">
                    <span v-t="`content.slider.more`"></span>
                    <m-icon icon="arrow-left" class="mr-1"/>
                  </button>
                </m-a>
              </div>
            </div>
          </swiper-slide>

        </swiper>


      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mA from '../../Tags/A'
import mImg from '../../Tags/Img'
import mIcon from '../../Icons/Icon'

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade} from 'swiper';
// Import Swiper styles
import "swiper/css";

import "swiper/css/navigation";
import 'swiper/css/effect-fade';

// import required modules
import {Navigation} from "swiper";


export default {
  name: "ContentSlider1",
  props: {
    contentType: {
      default: 'page'
    },
    contentCategory: {
      type: Object,
      default: ['header-slider']
    },
  },
  components: {Swiper, SwiperSlide, mContentWrapper, mA, mImg, mIcon,},
  setup() {
    return {
      modules: [Navigation, EffectFade],
    };
  },
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 2000,
        },
      },
    };
  },
};
</script>

<style>
/* slider buttons */

#slider302:hover > .swiper-wrapper .swiper-slide div a button {
  background-color: var(--primary) !important;
  color: var(--light) !important;
  transition: 0.4s ease-in-out all;
  height: 50px;
  border: none !important;
}

#slider302 > .swiper-wrapper .swiper-slide div a button {
  transition: 0.4s ease-in-out all;
}

/* slider buttons */
</style>

<style scoped>

.box-on-image {
  bottom: 8px;
  right: 16px;
}

.button-slider {
  text-align: right !important;
  width: 150px;
  background-color: var(--secondary) !important;
  color: var(--primary) !important;
  transition: 0.4s ease-in-out all;
  height: 1px;
  overflow: hidden;
  border: none !important;
}


.content-of-main-section:before {
  content: "";
  display: block;
  position: absolute;
  top: 75%;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.8;
  background-image: linear-gradient(180deg, rgba(42, 60, 110, 0) 0%, var(--dark) 100%);
}

.img-slider {
  width: 100%;
  object-fit: cover;
  max-height: 650px;
  min-height: auto;
  cursor: pointer;
}


</style>